/*** IMPORTS FROM imports-loader ***/
(function() {

define(['pip-model', 'pip-events', 'window'], function(pip, pipEvents, window){

    function initEventListeners() {
        pipEvents.requestQuote.dualPathRequestQuoteButtonClicked.off('.dualPathAnalytics');
        pipEvents.requestQuote.dualPathRequestQuoteButtonClicked.on('.dualPathAnalytics', function () {

            var thdAnalyticsEvent = {
                "category":{
                    primaryCategory: 'button submission'
                },
                "eventInfo":{
                    eventName: 'request a quote'
                },
                "item":[]
            };

            if (window.digitalData && window.digitalData.event) {
                window.digitalData.event.push(thdAnalyticsEvent);
            }
        });
    }

    return {
        init:  function init() {
            initEventListeners();
        }
    }
});

}.call(window));